$(document).ready(function () {
    dataLayer.push({ ecommerce: null });
    dataLayer.push({
        event: "view_item",
        ecommerce: {
            items: [
                {
                    item_name: $('#ShortDescription').val(),
                    item_id: $('#ItemName').val(),
                    price: $('#Price').val(),
                    currency: $('#Currency').val(),
                    quantity: $('#Quantity').val()
                        }]
        }
    });
});